import { useState, useEffect, useCallback } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";

/**
 * Custom hook for fetching and managing class data
 */
export const useClassData = (classId) => {
  const [classData, setClassData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchClassData = useCallback(async () => {
    if (!classId) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const classDocRef = doc(db, "classes", classId);
      const classDocSnap = await getDoc(classDocRef);

      if (classDocSnap.exists()) {
        setClassData(classDocSnap.data());
      } else {
        setError("Class not found");
        console.log("No such class document!");
      }
    } catch (error) {
      console.error("[useClassData] Error fetching class data:", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [classId]);

  useEffect(() => {
    fetchClassData();
  }, [fetchClassData]);

  return {
    classData,
    isLoading,
    error,
    refetch: fetchClassData,
  };
};

